import { render, staticRenderFns } from "./SingleStudentWorks.vue?vue&type=template&id=09dba824&scoped=true&"
import script from "./SingleStudentWorks.vue?vue&type=script&lang=js&"
export * from "./SingleStudentWorks.vue?vue&type=script&lang=js&"
import style0 from "./SingleStudentWorks.vue?vue&type=style&index=0&id=09dba824&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dba824",
  null
  
)

export default component.exports